var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14834 7.7244C4.34646 7.7244 2.88575 6.26369 2.88575 4.46181C2.88575 2.65993 4.34646 1.19922 6.14834 1.19922C7.95022 1.19922 9.41093 2.65993 9.41093 4.46181C9.41093 6.26369 7.95022 7.7244 6.14834 7.7244Z",
    fill: "#FBA12B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98245 9.40454C6.71 9.37236 6.43137 9.3557 6.14801 9.3557C3.00117 9.3557 0.438477 11.4111 0.438477 13.9437C0.438477 14.115 0.576661 14.2496 0.752532 14.2496H9.38887C7.67581 12.892 7.08913 10.8911 6.98245 9.40454Z",
    fill: "#FBA12B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84247 8.1746L11.8138 6.95113C11.9549 6.8925 12.1134 6.8925 12.2545 6.95113L15.2258 8.1746C15.4511 8.26891 15.5997 8.49321 15.5997 8.743C15.5997 10.3565 14.9584 13.0455 12.2644 14.2027C12.1183 14.2665 11.9524 14.2665 11.8063 14.2027C9.10989 13.0455 8.46859 10.3565 8.46859 8.743C8.46859 8.49321 8.61715 8.26891 8.84247 8.1746Z",
    fill: "#FBA12B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberAdmin);
export default __webpack_public_path__ + "static/media/MemberAdmin.cb406862873037fff7aecef9e0ce5c60.svg";
export { ForwardRef as ReactComponent };